export const licenseTypes = [
    {
        type: 'CC0',
        name: 'Creative Commons Zero (CC0)',
        url: 'https://creativecommons.org/publicdomain/zero/1.0/',
        attribution: 'Keine Namensnennung erforderlich',
        translations: {
            en: {
                name: 'Creative Commons Zero (CC0)',
                attribution: 'No attribution required'
            },
            fr: {
                name: 'Creative Commons Zéro (CC0)',
                attribution: 'Aucune attribution requise'
            },
            it: {
                name: 'Creative Commons Zero (CC0)',
                attribution: 'Nessuna attribuzione richiesta'
            }
        }
    },
    {
        type: 'CC BY',
        name: 'Creative Commons Namensnennung (CC BY)',
        url: 'https://creativecommons.org/licenses/by/4.0/',
        attribution: 'Namensnennung erforderlich',
        translations: {
            en: {
                name: 'Creative Commons Attribution (CC BY)',
                attribution: 'Attribution required'
            },
            fr: {
                name: 'Creative Commons Attribution (CC BY)',
                attribution: 'Attribution requise'
            },
            it: {
                name: 'Creative Commons Attribuzione (CC BY)',
                attribution: 'Attribuzione obbligatoria'
            }
        }
    },
    {
        type: 'CC BY-SA',
        name: 'Creative Commons Namensnennung-Weitergabe unter gleichen Bedingungen (CC BY-SA)',
        url: 'https://creativecommons.org/licenses/by-sa/4.0/',
        attribution: 'Namensnennung + Weitergabe unter gleichen Bedingungen erforderlich',
        translations: {
            en: {
                name: 'Creative Commons Attribution-ShareAlike (CC BY-SA)',
                attribution: 'Attribution + ShareAlike required'
            },
            fr: {
                name: 'Creative Commons Attribution-Partage dans les Mêmes Conditions (CC BY-SA)',
                attribution: 'Attribution + Partage dans les mêmes conditions requise'
            },
            it: {
                name: 'Creative Commons Attribuzione-Condividi allo stesso modo (CC BY-SA)',
                attribution: 'Attribuzione + Condividi allo stesso modo obbligatoria'
            }
        }
    },
    {
        type: 'CC BY-ND',
        name: 'Creative Commons Namensnennung-Keine Bearbeitung (CC BY-ND)',
        url: 'https://creativecommons.org/licenses/by-nd/4.0/',
        attribution: 'Namensnennung, keine Bearbeitung erlaubt',
        translations: {
            en: {
                name: 'Creative Commons Attribution-NoDerivatives (CC BY-ND)',
                attribution: 'Attribution, no modifications allowed'
            },
            fr: {
                name: 'Creative Commons Attribution-Pas de modifications (CC BY-ND)',
                attribution: 'Attribution, aucune modification autorisée'
            },
            it: {
                name: 'Creative Commons Attribuzione-Nessuna modifica (CC BY-ND)',
                attribution: 'Attribuzione, nessuna modifica consentita'
            }
        }
    },
    {
        type: 'CC BY-NC',
        name: 'Creative Commons Namensnennung-NichtKommerziell (CC BY-NC)',
        url: 'https://creativecommons.org/licenses/by-nc/4.0/',
        attribution: 'Namensnennung, nur nicht-kommerzielle Nutzung erlaubt',
        translations: {
            en: {
                name: 'Creative Commons Attribution-NonCommercial (CC BY-NC)',
                attribution: 'Attribution, non-commercial use only'
            },
            fr: {
                name: 'Creative Commons Attribution-Pas d’Utilisation Commerciale (CC BY-NC)',
                attribution: 'Attribution, usage non commercial uniquement'
            },
            it: {
                name: 'Creative Commons Attribuzione-NonCommerciale (CC BY-NC)',
                attribution: 'Attribuzione, solo uso non commerciale'
            }
        }
    },
    {
        type: 'CC BY-NC-SA',
        name: 'Creative Commons Namensnennung-NichtKommerziell-Weitergabe unter gleichen Bedingungen (CC BY-NC-SA)',
        url: 'https://creativecommons.org/licenses/by-nc-sa/4.0/',
        attribution: 'Namensnennung, nicht-kommerziell, Weitergabe unter gleichen Bedingungen',
        translations: {
            en: {
                name: 'Creative Commons Attribution-NonCommercial-ShareAlike (CC BY-NC-SA)',
                attribution: 'Attribution, non-commercial, share alike'
            },
            fr: {
                name: 'Creative Commons Attribution-Pas d’Utilisation Commerciale-Partage dans les Mêmes Conditions (CC BY-NC-SA)',
                attribution: 'Attribution, non commercial, partage dans les mêmes conditions'
            },
            it: {
                name: 'Creative Commons Attribuzione-NonCommerciale-Condividi allo stesso modo (CC BY-NC-SA)',
                attribution: 'Attribuzione, non commerciale, condividi allo stesso modo'
            }
        }
    },
    {
        type: 'CC BY-NC-ND',
        name: 'Creative Commons Namensnennung-NichtKommerziell-Keine Bearbeitung (CC BY-NC-ND)',
        url: 'https://creativecommons.org/licenses/by-nc-nd/4.0/',
        attribution: 'Namensnennung, nicht-kommerziell, keine Bearbeitung erlaubt',
        translations: {
            en: {
                name: 'Creative Commons Attribution-NonCommercial-NoDerivatives (CC BY-NC-ND)',
                attribution: 'Attribution, non-commercial, no modifications allowed'
            },
            fr: {
                name: 'Creative Commons Attribution-Pas d’Utilisation Commerciale-Pas de Modifications (CC BY-NC-ND)',
                attribution: 'Attribution, non commercial, aucune modification autorisée'
            },
            it: {
                name: 'Creative Commons Attribuzione-NonCommerciale-Nessuna Modifica (CC BY-NC-ND)',
                attribution: 'Attribuzione, non commerciale, nessuna modifica consentita'
            }
        }
    },
    {
        type: 'ODC-BY',
        name: 'ODC Namensnennungslizenz (ODC-BY)',
        url: 'https://opendatacommons.org/licenses/by/1-0/',
        attribution: 'Namensnennung erforderlich',
        translations: {
            en: {
                name: 'Open Data Commons Attribution License (ODC-BY)',
                attribution: 'Attribution required'
            },
            fr: {
                name: 'ODC Licence d’attribution (ODC-BY)',
                attribution: 'Attribution requise'
            },
            it: {
                name: 'ODC Licenza di attribuzione (ODC-BY)',
                attribution: 'Attribuzione obbligatoria'
            }
        }
    },
    {
        type: 'ODC-ODbL',
        name: 'ODC Datenbanklizenz (ODbL)',
        url: 'https://opendatacommons.org/licenses/odbl/1-0/',
        attribution: 'Namensnennung + Weitergabe unter gleichen Bedingungen erforderlich',
        translations: {
            en: {
                name: 'Open Data Commons Open Database License (ODbL)',
                attribution: 'Attribution + ShareAlike required'
            },
            fr: {
                name: 'ODC Licence de base de données ouverte (ODbL)',
                attribution: 'Attribution + partage dans les mêmes conditions requise'
            },
            it: {
                name: 'ODC Licenza per database aperti (ODbL)',
                attribution: 'Attribuzione + condividi allo stesso modo obbligatoria'
            }
        }
    },
    {
        type: 'ODC-PDDL',
        name: 'ODC Public Domain Lizenz (PDDL)',
        url: 'https://opendatacommons.org/licenses/pddl/1-0/',
        attribution: 'Keine Namensnennung erforderlich',
        translations: {
            en: {
                name: 'Open Data Commons Public Domain Dedication and License (PDDL)',
                attribution: 'No attribution required'
            },
            fr: {
                name: 'ODC Licence de domaine public (PDDL)',
                attribution: 'Aucune attribution requise'
            },
            it: {
                name: 'ODC Licenza dominio pubblico (PDDL)',
                attribution: 'Nessuna attribuzione richiesta'
            }
        }
    },
    {
        type: 'DL-DE-Zero',
        name: 'Datenlizenz Deutschland – Zero',
        url: 'https://www.govdata.de/dl-de/zero-2-0',
        attribution: 'Keine Namensnennung erforderlich',
        translations: {
            en: {
                name: 'Data License Germany – Zero (DL-DE-Zero)',
                attribution: 'No attribution required'
            },
            fr: {
                name: 'Licence de données Allemagne – Zero',
                attribution: 'Aucune attribution requise'
            },
            it: {
                name: 'Licenza dati Germania – Zero',
                attribution: 'Nessuna attribuzione richiesta'
            }
        }
    },
    {
        type: 'DL-DE-BY',
        name: 'Datenlizenz Deutschland – Namensnennung',
        url: 'https://www.govdata.de/dl-de/by-2-0',
        attribution: 'Namensnennung erforderlich',
        translations: {
            en: {
                name: 'Data License Germany – Attribution (DL-DE-BY)',
                attribution: 'Attribution required'
            },
            fr: {
                name: 'Licence de données Allemagne – Attribution',
                attribution: 'Attribution requise'
            },
            it: {
                name: 'Licenza dati Germania – Attribuzione',
                attribution: 'Attribuzione obbligatoria'
            }
        }
    },
    {
        type: 'OGLv3',
        name: 'Offene Regierungsdatenlizenz v3 (UK)',
        url: 'https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/',
        attribution: 'Namensnennung erforderlich',
        translations: {
            en: {
                name: 'Open Government License v3 (UK)',
                attribution: 'Attribution required'
            },
            fr: {
                name: 'Licence gouvernementale ouverte v3 (UK)',
                attribution: 'Attribution requise'
            },
            it: {
                name: 'Licenza governativa aperta v3 (UK)',
                attribution: 'Attribuzione obbligatoria'
            }
        }
    },
    {
        type: 'Etalab',
        name: 'Etalab Open License (Frankreich)',
        url: 'https://www.etalab.gouv.fr/licence-ouverte-open-licence',
        attribution: 'Namensnennung erforderlich',
        translations: {
            en: {
                name: 'Licence Ouverte / Open Licence (France)',
                attribution: 'Attribution required'
            },
            fr: {
                name: 'Licence Ouverte (Etalab)',
                attribution: 'Attribution requise'
            },
            it: {
                name: 'Licenza Aperta (Etalab)',
                attribution: 'Attribuzione obbligatoria'
            }
        }
    },
    {
        type: 'NLOD',
        name: 'Norwegische Lizenz für offene Regierungsdaten (NLOD)',
        url: 'https://data.norge.no/nlod/en/2.0',
        attribution: 'Namensnennung erforderlich',
        translations: {
            en: {
                name: 'Norwegian Licence for Open Government Data (NLOD)',
                attribution: 'Attribution required'
            },
            fr: {
                name: 'Licence norvégienne pour les données publiques ouvertes (NLOD)',
                attribution: 'Attribution requise'
            },
            it: {
                name: 'Licenza norvegese per i dati pubblici aperti (NLOD)',
                attribution: 'Attribuzione obbligatoria'
            }
        }
    },
    {
        type: 'Other',
        name: 'Andere',
        url: '',
        attribution: 'Benutzerdefinierte oder nicht angegebene Lizenz',
        translations: {
            en: {
                name: 'Other',
                attribution: 'Custom or unspecified license'
            },
            fr: {
                name: 'Autre',
                attribution: 'Licence personnalisée ou non spécifiée'
            },
            it: {
                name: 'Altro',
                attribution: 'Licenza personalizzata o non specificata'
            }
        }
    }
];
